import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
export default function ForgotPassword(){
  const [email,setEmail] = useState('');
  const [sent,setSent] = useState(false);
  
  const handleReset = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/request-password-reset", { email });
      setSent(true);
    } catch (err) {
      console.error(err);
      setSent(true); // still show success for security
    }
  };


  //bfore intergration code
  /*const handleReset = (e) => {
    e.preventDefault();
    // call backend to send reset email
    setSent(true);
  };*/


  return (
    <div className="auth-container">
      <h2>Forgot Password</h2>
      <form onSubmit={handleReset}>
        <div className="input-wrap">
          <input type="email" placeholder="Enter your registered email" value={email}
            onChange={(e)=>setEmail(e.target.value)} required />
        </div>
        <button className="primary" type="submit">Send Reset Link</button>
      </form>
      {sent && <p className="success">Password reset link sent to {email} (mock)</p>}
      <p className="switch-line">Remembered? <Link to="/">Sign In</Link></p>
    </div>
  );
}
